export default __webpack_public_path__ + "static/GavulaXMas--2023-25aa54386a6df7eed0bab720aa1b9eab.pdf";